import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';

export default class Block06 {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.gsap = gsap;

        this.init();
    }

    init () {
        this.gsap.registerPlugin(ScrollTrigger);

        this.file();

        if (window.innerWidth > 767) {
            this.animation();
        } else {
            this.mobile();
        }
    }

    file () {
        const file = this.el.querySelector('.block-06--form-file input[type="file"]');
        if (!file) return;

        const name = this.el.querySelector('.block-06--form-file-name');
        if (!name) return;

        file.addEventListener('change', () => {
            name.textContent = file.files.length ? file.files[0].name : 'No file chosen';
        });
    }

    animation () {
        const title = this.el.querySelector('.site-section--heading .site-title');
        const text = this.el.querySelector('.site-section--heading .site-text');
        const card = this.el.querySelector('.block-06--booking-card');

        new SplitType(title, { types: 'chars' });

        /* Step: Content */

        {
            const timeline = this.gsap.timeline({
                scrollTrigger: {
                    trigger: this.el,
                    start: () => 'top bottom',
                    end: () => `+=${window.innerHeight}px`,
                    scrub: true
                }
            });

            timeline
                .set(text,     { opacity: 0, y: '50%' })
                .set(card,     { opacity: 0 })
                .to({},        { duration: 0, onUpdate: () => title.classList.remove('animated') })
                .to({},        { duration: 1 })
                .to({},        { duration: 1, onUpdate: () => title.classList.add('animated') })
                .to(text,      { duration: 1, opacity: 1, y: 0 })
                .to(card,      { duration: 2, opacity: 1 })
        }
    }

    mobile () {
        const title = this.el.querySelector('.site-section--heading .site-title');
        const text = this.el.querySelector('.site-section--heading .site-text');
        const card = this.el.querySelector('.block-06--booking-card');
        
        title.classList.add('site-animation', 'fade-up');
        text.classList.add('site-animation', 'fade-up');
        card.classList.add('site-animation', 'fade-in');

        [title, text, card].forEach((element) => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom',
                    once: true,
                    onEnter: () => element.classList.add('animated')
                }
            });
        });
    }
}